export const containerQueries = {
  isNarrowContainer: {
    maxWidth: 910,
  },
}
